import { createAttendee, prepareHomeLink } from './utils-module.js';
import {
  isAssignedAttendeeUid,
  isNeedToShowPrivacy,
  redirectToHome,
  initRegForm,
  generateUrlForEmail,
  saveRegData,
} from './main-registration.js';
import { captureEvents } from '../../../packages/src/api/index.js';
import { assertPageParams, validationVariants, pageParams, fetchData } from './page.js';
import { setBackground, setLogo } from './customizePage/registration.js';

const { isSetUpHomeLink, isSetUpEventName } = validationVariants;
const { eventName } = pageParams;

const form = initRegForm();

async function init() {
  assertPageParams([isSetUpEventName, isSetUpHomeLink]);

  if (isAssignedAttendeeUid()) {
    redirectToHome();
  }

  const event = await fetchData.event();

  const { opts } = event;

  setLogo(opts.webappCustomLogoSrc);
  setBackground(opts.webappCustomBackgroundSrc);

  if (isNeedToShowPrivacy(opts)) {
    form.enableAgreePrivacy();
  }

  form.onSubmit(async ({ name, email }) => {
    const { result: attendeeUid } = await createAttendee({
      eventCode: eventName(),
      name,
      email,
      appURL: generateUrlForEmail(),
    });
    saveRegData({ attendeeUid });
    await captureEvents({
      EventSource: 'WebApp',
      EventName: 'Registration',
      EventType: 'info',
      EventCode: event.name,
      OrganisationId: event.organisation_id,
      EventFullName: event.full_name,
      AttendeeUid: attendeeUid,
      Count: '1',
      EventDate__date: Date.now(),
    });
    window.location.href = prepareHomeLink(attendeeUid);
  });
}

document.addEventListener('DOMContentLoaded', init);
